import * as React from 'react';
import { useCallback } from 'react';

import { PaywallTouchEventAdapter } from '~analytics/adapters/PaywallTouchEventAdapter';
import { PaywallScreens } from '~analytics/types';
import { translate } from '~l10n/client';
import { UIButton } from '~shared/components/buttons';
import { Dialog, DialogTitle } from '~shared/components/Dialog';
import { Inline } from '~shared/components/Inline';
import { Stack } from '~shared/components/Stack';
import { DialogProps, useDialog } from '~shared/context/AsyncDialogContext';

import { PaywallUpgradeButton } from './PaywallUpgradeButton';

const paywallScreen = PaywallScreens.InsightsGenerateQuestionsSpecificStudents;

function PaywallDialogSpecificStudents({ onResolve }: DialogProps) {
  React.useEffect(() => {
    new PaywallTouchEventAdapter(paywallScreen).sendAnalytics();
  }, []);

  return (
    <Dialog
      id="paywall-specific-students"
      title={translate('Upgrade to Generate from Specific Students')}
      padding="confirmation"
      open={true}
      onClose={() => onResolve({ success: false })}
      closeLabel={translate('Close')}
    >
      {(headerProps) => (
        <Stack space="8">
          <h3 className="m-0">
            <DialogTitle ref={headerProps.headingRef}>
              {headerProps.title}
            </DialogTitle>
          </h3>
          <div className="font-sans text-sm leading-8 text-blue-900">
            {translate(
              'Generate questions based on individual student responses to revisit concepts, re-engage students or target practice areas.'
            )}
          </div>
          <Inline align="right">
            <UIButton key="cancel" onClick={() => onResolve({ success: false })}>
              {translate('Cancel')}
            </UIButton>
            <PaywallUpgradeButton
              key="upgrade"
              appearance="primary"
              paywallScreen={paywallScreen}
            />
          </Inline>
        </Stack>
      )}
    </Dialog>
  );
}

export function useOpenPaywallDialogSpecificStudents() {
  const { openDialog } = useDialog();

  return useCallback(async () => {
    await openDialog(PaywallDialogSpecificStudents);
  }, [openDialog]);
}
